import type { JSX } from 'react';

import { useStepState } from 'src/app/pages/startAPetition/pageContext';

import { STEP_MAP } from './constants';

// eslint-disable-next-line @typescript-eslint/no-empty-function
const noop = () => {};

export function StepBody(): JSX.Element {
	const { data } = useStepState();
	const CurrentStepComponent = STEP_MAP[data.currentStep.name].component;
	const preloadNextStep = data.nextStep ? STEP_MAP[data.nextStep.name].preload : noop;

	// preload the next step
	void preloadNextStep();

	return <CurrentStepComponent />;
}
